var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8235 0H5.17647C2.31758 0 0 2.38781 0 5.33333V26.6667C0 29.6122 2.31758 32 5.17647 32H38.8235C41.6824 32 44 29.6122 44 26.6667V5.33333C44 2.38781 41.6824 0 38.8235 0Z",
    fill: "#1F72CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88797 11.333L3.77124 20.9953H8.69955L9.31052 19.4547H10.7071L11.318 20.9953H16.7427V19.8195L17.2261 20.9953H20.0321L20.5155 19.7946V20.9953H31.7973L33.1692 19.4947L34.4538 20.9953L40.2483 21.0078L36.1186 16.1911L40.2483 11.333H34.5436L33.2082 12.8058L31.9641 11.333H19.691L18.637 13.8269L17.5584 11.333H12.6404V12.4688L12.0933 11.333H7.88797ZM8.84158 12.7051H11.2439L13.9745 19.2571V12.7051H16.6061L18.7152 17.4029L20.659 12.7051H23.2775V19.6385H21.6842L21.6711 14.2055L19.3483 19.6385H17.9231L15.5872 14.2055V19.6385H12.3095L11.6881 18.0841H8.33091L7.71081 19.637H5.95464L8.84158 12.7051ZM31.2137 12.7051H24.7351V19.6343H31.1134L33.1692 17.3378L35.1506 19.6343H37.222L34.2114 16.1898L37.222 12.7051H35.2406L33.1952 14.9751L31.2137 12.7051ZM10.0102 13.8782L8.90415 16.6471H11.115L10.0102 13.8782ZM26.335 15.4063V14.1406V14.1394H30.3774L32.1413 16.1635L30.2992 18.1987H26.335V16.817H29.8693V15.4063H26.335Z",
    fill: "white"
  })));
}

export default SvgAmex;